import {
  constructFeaturebaseJwtUrl,
  isValidFeaturebaseUrl,
} from '@griply/utils';

// The Framer roadmap page reads the token from this hash parameter.
const ROADMAP_EMBED_URL = 'https://griply.app/roadmap';
const ROADMAP_EMBED_TOKEN_PARAM = 'featurebaseJwt';

// The hash never reaches a server log or a Referer header, unlike a query parameter.
export const getFeaturebaseSsoRedirect = (
  returnTo: string,
): ((token: string) => string) | null => {
  if (returnTo === ROADMAP_EMBED_URL) {
    return (token) =>
      `${ROADMAP_EMBED_URL}#${ROADMAP_EMBED_TOKEN_PARAM}=${encodeURIComponent(token)}`;
  }

  if (isValidFeaturebaseUrl(returnTo)) {
    return (token) => constructFeaturebaseJwtUrl(token, returnTo);
  }

  return null;
};
